import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Satya.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import axios from 'axios';
import city from '../../../city.json'



// Long-form popup content for key terms
const termInfo = {
  "Purnima": {
    name: "Purnima",
    description: "Purnima (Pournami) is the full-moon day in the lunar cycle, observed once every month in the Hindu calendar.",
    significance: "It is considered highly auspicious for vrats, pujas, and spiritual activities. Satyanarayana Puja performed on Purnima is believed to bring prosperity and harmony.",
    culturalAspect: "Devotees often fast, visit temples, and perform special rituals on Purnima. Different regions observe unique festivals like Guru Purnima, Sharad Purnima, and Buddha Purnima."
  },
  "Panchamritam": {
    name: "Panchamritam",
    description: "Panchamritam is a sacred mixture traditionally made from milk, curd (yogurt), ghee, honey, and sugar.",
    significance: "It is used in abhishekam (ritual bathing) of deities and distributed as prasadam, symbolizing purity and divine blessings.",
    culturalAspect: "Some traditions enrich Panchamritam with fruits or dry fruits. It is a central offering in many pujas, including Satyanarayana Puja."
  }
};




const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const Satya = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [satyaList, setSatyaList] = useState([]);
  const [popupFestival, setPopupFestival] = useState(null);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSatya, setSelectedSatya] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const satyanarayanaTooltips = {
  "Shri Satyanarayana Vrat": "Shri Satyanarayana Vrat is a highly revered Hindu ritual dedicated to Lord Vishnu in his Satyanarayana form. It is usually observed on Purnima (full moon day) and involves a special puja, storytelling (katha), fasting, and offerings to seek blessings for prosperity, harmony, and the fulfillment of wishes."
}


useEffect(() => {
  const fetchSatyaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/satyanarayana-puja?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.satyanarayanaPuja) {
        setSatyaList(response.data.satyanarayanaPuja);
      } else {
        setSatyaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch satya data:", error);
      setSatyaList([]);
    }
  };

  fetchSatyaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};




  return (
    <div className="Satya-container">
      <InnerNav />
      <div className="Satya-content">
        <Zodiac />

        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Satyanarayana Puja Dates</h2>
              <div className="current-ekadashi">
                <img
                  src="https://i.pinimg.com/1200x/16/ca/7e/16ca7e1da70c31963f2fe7ba08e21b2d.jpg"
                  alt="Satya Puja"
                  className="moon-preview"
                />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Satya-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedSatya ? (
  <div className="satya-list">
    {satyaList.length === 0 && (
      <p>No satyanarayana puja data available for selected year/location.</p>
    )}

    {satyaList.map((item, idx) => (
      <div
        className="satya-item clickable"
        key={idx}
        onClick={() => setSelectedSatya(item)}
      >
        <img
          src="https://i.pinimg.com/1200x/16/ca/7e/16ca7e1da70c31963f2fe7ba08e21b2d.jpg"
          alt="satyanarayan puja"
        />

        <div className="satya-details">
          <p className="satya-date">{item.date}</p>

          <div className="tooltip-wrapper">
            <div className="satya-name">{item.title}</div>
            <span className="tooltip-text">
              {satyanarayanaTooltips[item.title] || "No info available"}
            </span>
          </div>

          <p className="satya-phase">{item.muhurta}</p>
          <p className="satya-tithi">{item.tithiName}</p>
          <p className="satya-tithi">{item.duration}</p>
        </div>

        <div className="satya-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
        <hr />

<div className="detail-section">
  <h3>🪔 About Shri Satyanarayana Puja</h3>
  <p>
    Shri Satyanarayana Puja is a sacred Hindu ritual dedicated to
    Lord Vishnu in his Satyanarayana form, symbolizing truth,
    righteousness, and divine order.
  </p>
</div>

<div className="detail-section">
  <h3>📿 Spiritual Significance</h3>
  <p>
    Performing this puja on Purnima is believed to bring prosperity,
    family harmony, good health, and mental peace. It is especially
    auspicious for households beginning new ventures or seeking
    stability.
  </p>
</div>

<div className="detail-section">
  <h3>👨‍👩‍👧‍👦 Who Can Perform This Puja</h3>
  <ul>
    <li>Families seeking peace and prosperity</li>
    <li>Newly married couples</li>
    <li>People facing financial or personal difficulties</li>
    <li>Devotees wishing to express gratitude after wish fulfillment</li>
  </ul>
</div>

<div className="detail-section">
  <h3>🙏 Simple Observance Guidelines</h3>
  <ul>
    <li>Maintain cleanliness and a calm mind</li>
    <li>Light a lamp and offer fruits or sweets</li>
    <li>Listen to or read Satyanarayana Katha</li>
    <li>Fasting is optional and can be partial</li>
  </ul>
</div>

      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedSatya(null)}
    >
      ← Back
    </button>

    <h2>{selectedSatya.title}</h2>

    <img
      src="https://i.pinimg.com/1200x/16/ca/7e/16ca7e1da70c31963f2fe7ba08e21b2d.jpg"
      alt={selectedSatya.title}
    />

    <p><strong>Date:</strong> {selectedSatya.date}</p>
    <p><strong>Muhurta:</strong> {selectedSatya.muhurta}</p>
    <p><strong>Tithi:</strong> {selectedSatya.tithiName}</p>
    <p><strong>Duration:</strong> {selectedSatya.duration}</p>

    <p><strong>Lunar Detail:</strong> {selectedSatya.lunarDetail}</p>

    <p><strong>Tithi Start:</strong> {formatTime(selectedSatya.tithiStart, timeFormat)}</p>
    <p><strong>Tithi End:</strong> {formatTime(selectedSatya.tithiEnd, timeFormat)}</p>
  </div>
)}

        </div>
        <section className="satyanarayana-wrapper">
      <h1 className="satyanarayana-title">Shri Satyanarayana Puja and Katha Dates</h1>
      <div className="satyanarayana-texts">
        <p>
          Shri Satyanarayana Puja is performed to seek blessing of God Narayan which is one of the forms of Lord Vishnu. The Lord in this form is considered an embodiment of truth. Although there is no fixed day to perform Satyanarayana Puja but doing it during 
          <span className="popup-link" onClick={() => setPopupFestival("Purnima")}> Purnima</span> 

         
          or <strong>Pournami</strong> is considered highly auspicious.
        </p>

        <p>
          Devotees should observe the fast on Puja day. The Puja can be done in the morning as well as in the evening. However performing Satyanarayana Puja in the evening is considered more appropriate as devotees can break the fast with Prasadam in the evening.
        </p>

        

        <p>
          Puja rituals consist of worshipping Lord Satyanarayana which is an extremely benevolent form of Lord Vishnu. 
          <span className="popup-link" onClick={() => setPopupFestival("Panchamritam")}> Panchamritam</span> 

           
          (a mixture of milk, honey, ghee/butter, yogurt and sugar) is used to clean the deity, usually Saligram, which is divine stone of Maha Vishnu. Panjiri, which is sweet roasted flour of wheat, banana and other fruits are used as Prasad. Tulasi leaves are added into Prasad to make it sacred.
        </p>

        <p>
          Another requirement of the Puja is that the story of the Puja, also known as <strong>Katha</strong>, is listened by those who are participating as well as by those who are observing the fast. The Satyanarayana Katha involves the origin of the Puja, the benefits of the Puja and the potential mishaps that might occur if one forgets to perform the Puja.
        </p>

        <p>
          The Puja concludes with an Aarti, which consists of revolving a small fire ignited with Kapoor in the vicinity of an image or deity of the Lord. After Aarti participants and Vrat observers are required to consume the Panchamritam and the Prasad. Vrat observers can consume Prasdam after breaking the fast with Panchamritam.
        </p>
      </div>
    </section>
        <VratLinks/>
      </div>
      <Footer />
      {popupFestival && (
  <div className="popup-overlay" onClick={() => setPopupFestival(null)}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <h2>{termInfo[popupFestival].name}</h2>
      <p><strong>Description:</strong> {termInfo[popupFestival].description}</p>
      <p><strong>Significance:</strong> {termInfo[popupFestival].significance}</p>
      <p><strong>Cultural Aspect:</strong> {termInfo[popupFestival].culturalAspect}</p>

      <button className="close-btn" onClick={() => setPopupFestival(null)}>Close</button>
    </div>
  </div>
)}
    </div>
  );
};

export default Satya;
